import { ReactNode } from 'react';
import { PATHS, twMerge } from '@belong/common';
import { Text } from '@belong/ui';
import LinkBase from 'corecomponents/LinkBase/LinkBase';
import { STRINGS } from 'post-inspection/constants/strings';

type Props = {
  children?: ReactNode;
  className?: string;
};

export const QuestionsOrConcernsModalFooter = ({
  children,
  className,
}: Props) => (
  <div
    className={twMerge(
      'flex w-full flex-col-reverse rounded-b px-0 sm:flex-row sm:px-2sm md:flex md:justify-between md:border-0 md:border-t md:border-solid md:border-dark-gray md:bg-light-gray md:p-sm',
      className,
    )}
  >
    <div className="mt-lg flex shrink-0 items-center justify-center sm:mb-sm sm:mt-0 sm:flex-row md:mb-0 md:justify-start">
      <Text>{STRINGS['questions-or-concerns']}</Text>
      &nbsp;
      <div className="h-md lg:h-auto">
        <LinkBase href={PATHS.SUPPORT}>
          <Text fontWeight="semibold" className="uppercase hover:text-green">
            {STRINGS['lets-talk']}
          </Text>
        </LinkBase>
      </div>
    </div>
    {children}
  </div>
);
